import { Component } from 'react';

import './home-play-sessions-table.css';

import AssignHomeSessionDialog from './assign-home-session-dialog';

class HomePlaySessionsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_add_session_dialog: false,
    };
  }

  createSessionRows(sessions) {
    if (sessions && sessions.length > 0) {
      return sessions.map((session) => {
        return (
          <tr className="home_play_session_row">
            <td className="home_play_td">{session.name}</td>
            <td className="home_play_td">{session.owner}</td>
          </tr>
        );
      });
    } else {
      return '';
    }
  }

  showAddHomeSessionDialog() {
    this.setState({ show_add_session_dialog: true });
  }

  hideAddHomeSessionDialog() {
    this.setState({ show_add_session_dialog: false });
  }

  render() {
    const { sessions, player } = this.props;

    const { show_add_session_dialog } = this.state;

    return (
      <div className="home_play_sessions_table_container">
        <div className="home_play_table_title">Active Home Sessions</div>
        <div className="home_play_table_wrapper">
          <table className="home_play_sessions_table">
            <thead>
              <tr>
                <th className="home_play_th">Session Name</th>
                <th className="home_play_th">Session Owner</th>
              </tr>
            </thead>
            <tbody>{this.createSessionRows(sessions)}</tbody>
          </table>
        </div>
        <button className="add_home_session_button" onClick={this.showAddHomeSessionDialog.bind(this)}>
          Add Home Play Session
        </button>
        <AssignHomeSessionDialog
          player={player}
          show={show_add_session_dialog}
          hide_func={this.hideAddHomeSessionDialog.bind(this)}
        />
      </div>
    );
  }
}

export default HomePlaySessionsTable;
